"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[7382,9401],{

/***/ 7382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PDPRecommendationsV2)
/* harmony export */ });
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1732);
/* harmony import */ var _utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9401);



function PDPRecommendationsV2() {
  if (!customElements.get('pdp-recommendations-v2-swiper')) {
    customElements.define(
      'pdp-recommendations-v2-swiper',
      class PDPRecommendationsV2Swiper extends HTMLElement {
        constructor() {
          super()
          this.swiper = null
          this.init = this.init.bind(this)
          this.init()
        }

        init() {
          this.initSwiper()
        }

        initSwiper() {
          const swiperElement = this.querySelector('.swiper')
          if (!swiperElement) return

          // Destroy existing swiper if it exists
          if (this.swiper) {
            this.swiper.destroy(true, true)
          }

          // Wait for DOM to be ready
          let retryCount = 0
          const maxRetries = 20 // 1 second max wait time

          const initSwiperInstance = () => {
            const nextBtn = swiperElement.querySelector('.swiper-button-next')
            const prevBtn = swiperElement.querySelector('.swiper-button-prev')

            if ((!nextBtn || !prevBtn) && retryCount < maxRetries) {
              retryCount++
              setTimeout(initSwiperInstance, 50)
              return
            }

            if (nextBtn && prevBtn) {
              if (this.dataset.productPage === 'true') {
                this.swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A(swiperElement, {
                  slidesPerView: 'auto',
                  pagination: {
                    el: '.rec-products-pagination',
                    type: 'bullets',
                    bulletActiveClass: 'on',
                    bulletClass: 'bullet block w-2.5 aspect-square rounded-full border-0 bg-galaxy/20 on:bg-galaxy',
                  },
                  navigation: {
                    nextEl: '.rec-products-next',
                    prevEl: '.rec-products-prev',
                  },
                  breakpoints: {
                    1024: {
                      slidesPerView: 2,
                      spaceBetween: 16,
                    },
                  },
                })

                // Add accessibility
                ;(0,_utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_1__.addSwiperAccessibility)(this.swiper)
              } else {
                this.swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A(swiperElement, {
                  slidesPerView: 1,
                  centeredSlides: true,
                  loop: true,
                  navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                  },
                  keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                  },
                  pagination: {
                    el: '.cart-rec-pagination',
                    type: 'bullets',
                    bulletActiveClass: 'on',
                    bulletClass: 'bullet block w-2 aspect-square rounded-full bg-galaxy/20 border-0 on:bg-galaxy',
                  },
                })

                // Add accessibility
                ;(0,_utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_1__.addSwiperAccessibility)(this.swiper)
              }
            }
          }

          initSwiperInstance()
        }
      }
    )
  }

  if (!customElements.get('product-recommendations-api')) {
    customElements.define(
      'product-recommendations-api',
      class ProductRecommendationsAPI extends HTMLElement {
        constructor() {
          super()
          this.init = this.init.bind(this)
          this.init()
        }

        init() {
          const hasLoaded = this.dataset.recommendationsPerformed !== undefined
          if (hasLoaded) return

          const url = this.dataset.url
          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div')
              html.innerHTML = text
              const recommendations = html.querySelector('.product-recommendations')
              if (recommendations && recommendations.innerHTML.trim().length) {
                // Find every anchor tag within this element and add target="_blank"
                const anchors = recommendations.querySelectorAll('a')
                anchors.forEach((anchor) => {
                  anchor.setAttribute('target', '_blank')
                })
                this.replaceWith(recommendations)

                // Reinitialize Swiper after content is loaded
                setTimeout(() => {
                  const newSwiperElement = document.querySelector('pdp-recommendations-v2-swiper')
                  if (newSwiperElement && newSwiperElement.initSwiper) {
                    newSwiperElement.initSwiper()
                  }
                }, 100)
              }
            })
            .catch((e) => {
              console.error(e)
            })
        }
      }
    )
  }
}


/***/ }),

/***/ 9401:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addSwiperAccessibility: () => (/* binding */ addSwiperAccessibility)
/* harmony export */ });
// utility to add accessibility attributes to swiper slides
function addSwiperAccessibility(swiper) {
  const container = swiper.el
  let intersectionObserver = null
  
  // Function to update slide accessibility
  function updateSlideAccessibility() {
    const slides = container.querySelectorAll('.swiper-slide')
    
    // Stop observing all slides first
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.unobserve(slide)
      }
    })

    // Start observing all slides
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.observe(slide)
      }
    })

  }
  
  // Create intersection observer to track slide visibility
  intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const slide = entry.target
        const isVisible = entry.isIntersecting

        if (isVisible) {
          // Slide is visible - remove aria-hidden and tabindex, restore inner elements
          slide.removeAttribute('aria-hidden')
          slide.removeAttribute('tabindex')
          restoreTabbableElements(slide)
        } else {
          // Slide is not visible - add aria-hidden and tabindex="-1", disable inner elements
          slide.setAttribute('aria-hidden', 'true')
          slide.setAttribute('tabindex', '-1')
          disableTabbableElements(slide)
        }
      })
    },
    {
      root: container,
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of the slide is visible
    }
  )
  
  // Function to disable tabbable elements in hidden slides
  function disableTabbableElements(slide) {
    const tabbableElements = slide.querySelectorAll(
      'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('tabindex')) {
        element.setAttribute('data-original-tabindex', element.getAttribute('tabindex'))
      }
      element.setAttribute('tabindex', '-1')
    })
  }
  
  // Function to restore tabbable elements in visible slides
  function restoreTabbableElements(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      return
    }
    
    const tabbableElements = slide.querySelectorAll('[tabindex="-1"]')
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('data-original-tabindex')
        if (originalTabindex !== '-1') {
          element.setAttribute('tabindex', originalTabindex)
        } else {
          element.removeAttribute('tabindex')
        }
        element.removeAttribute('data-original-tabindex')
      } else {
        element.removeAttribute('tabindex')
      }
    })
  }
  
  setTimeout(() => {
    updateSlideAccessibility()
  }, 100)
  
  // Update on slide change
  swiper.on('activeIndexChange', function () {
    updateSlideAccessibility()
  })
}


/***/ })

}]);